import React from 'react';
import { Link } from 'react-router-dom';
import businessAnalysis from '../images/business-analysis-icon.svg';
import productOwner from '../images/product-owner-icon.svg';
import scrumMaster from '../images/scrum-master-icon.svg';

// Import SVG icons with correct paths
const DienstenPage = () => {
  const services = [
    {
      title: "Business Analist",
      icon: businessAnalysis,
      description: "Als ervaren Business Analist vorm ik de cruciale schakel tussen business en IT. Ik vertaal complexe bedrijfsbehoeften naar concrete oplossingen.",
      details: [
        "Identificeren en documenteren van requirements",
        "Procesanalyse en optimalisatie",
        "Stakeholder management en communicatie",
        "Data analyse en modellering",
        "Implementatie ondersteuning"
      ],
      fullDescription: "Met een pragmatische aanpak zorg ik voor heldere documentatie die direct toepasbaar is. Ik werk nauw samen met alle belanghebbenden om requirements scherp te krijgen en vertaal deze naar concrete oplossingen. Door mijn ervaring in zowel business als IT kan ik effectief communiceren met alle niveaus in de organisatie."
    },
    {
      title: "Product Owner",
      icon: productOwner,
      description: "Als Product Owner ben ik verantwoordelijk voor het maximaliseren van de productwaarde en het bereiken van businessdoelen.",
      details: [
        "Product visie en strategie",
        "Backlog management en prioritering",
        "Stakeholder alignment",
        "Release planning",
        "Value optimization"
      ],
      fullDescription: "Ik werk nauw samen met stakeholders om de product roadmap te definiëren en beheren. Door continue focus op waarde voor de eindgebruiker en zakelijke doelstellingen, zorg ik voor de juiste prioriteiten in de product backlog. Ik vertaal strategische doelen naar concrete user stories en maak heldere keuzes in wat er wel en niet ontwikkeld wordt."
    },
    {
      title: "Scrum Master & Agile Coach",
      icon: scrumMaster,
      description: "Als Scrum Master en Agile Coach help ik teams en organisaties om effectiever samen te werken en betere resultaten te behalen.",
      details: [
        "Team coaching en facilitatie",
        "Agile transitie begeleiding",
        "Impediment removal",
        "Scrum implementatie",
        "Continue verbetering"
      ],
      fullDescription: "Ik ondersteun teams in hun ontwikkeling naar high-performance door het faciliteren van Scrum events en het coachen op Agile principes. Met focus op empirisch proces control en self-organization help ik teams groeien en excelleren. Daarnaast begeleid ik organisaties in hun Agile transformatie door praktische toepassing van Agile waardes en principes."
    }
  ];

  return (
    <main className="diensten-page">
      <section className="diensten-hero">
        <div className="diensten-hero-content">
          <h1>Pragmatische Agile Dienstverlening</h1>
          <p>Met jarenlange ervaring in verschillende Agile rollen help ik organisaties met het implementeren van werkende oplossingen. Focus op waarde, transparante communicatie en praktische aanpak.</p>
        </div>
      </section>

      <section className="diensten-services">
        <div className="diensten-services-grid">
          {services.map((service, index) => (
            <div key={index} className="dienst-service-card">
              <div className="dienst-service-content">
                <div className="dienst-service-icon">
                  <img src={service.icon} alt={service.title} />
                </div>
                <h2>{service.title}</h2>
                <p className="dienst-service-description">{service.description}</p>
                <ul className="dienst-service-details">
                  {service.details.map((detail, idx) => (
                    <li key={idx}>{detail}</li>
                  ))}
                </ul>
                <p className="dienst-service-full">{service.fullDescription}</p>
                <Link to="/contact" className="dienst-service-cta btn-primary">
                  Neem contact op
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="diensten-cta">
        <div className="diensten-cta-content">
          <h2>Klaar om uw Agile reis te versterken?</h2>
          <p>Laten we samen kijken hoe ik uw organisatie kan helpen met pragmatische Agile oplossingen.</p>
          <Link to="/contact" className="btn-primary">
            Plan een gesprek
          </Link>
        </div>
      </section>
    </main>
  );
};

export default DienstenPage;